import {React, useEffect, useState} from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import BrandLogoSlider from "../BrandLogoSlider/BrandLogoSlider";
import { Link } from "react-router-dom";
import RASelect from 'react-select/async';
import "./IndividualSignUp.styles.css";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userRegistration , commonPost, commonGet} from "../../services/auth";
import { useNavigate } from 'react-router-dom';
import CustomDateTimePicker from '../InputField/CustomDateTimePicker'; 

const IndividualSignUp = ({ firstProp, secondProp }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [dob, setDob] = useState(null);
  const [individualSignUpData,setIndividualSignUpData] = useState({
    email: "",
    passWord: "",
    cPassWord: "",
    fName: "",
    lName: "",
    gender: "",
    dob: "",
    address: "",
    city: "SG",
    state: "SG",
    zipCode: "",
    country: "SG",
    contactNo: "",
    confirmationBox: false,
  });

  const signUpFormSubmitHandler = async (values) => {
    const url = "accounts/register"
    const val = {
      roletype: "Individual",
      email: values.email,
      username: values.username.toLowerCase(),
      password: values.passWord,
      confirmpassword: values.cPassWord,
      firstname: values.fName,
      lastname: values.lName,
      gender: values.gender,
      dob: dob,
      addr1: addValue,//values.address,
      addr2: values.address,
      city: cityValue,
      postcode: postValue,//values.postalcode.toString(),
      state: stateValue,//values.state,
      country: countryValue,//values.country,
      mobile: values.contactNo.toString(),
      acceptTerms: values.confirmationBox
    }
    await userRegistration(val, url).then(response=>{
      if (response && response.status == 200) {
        toast.success('Registration Successful. Please click on the link sent in the email to verify your account.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
        navigate('/login');
      }
      else if (response && response.status == 202) {
        toast.warning('Username already used. Please use another username or check your mail for more details.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          transition: Slide,
        });
      }
      else if(response?.message){
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    })
  }
  toast.configure();

  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('Singapore');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('Singapore');
  const [cityValue, setCityValue] = useState('Singapore');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [addValue, setAddValue] = useState('');
  const [addValueChange, setAddValueChange] = useState('');
  const [postValue, setPostValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(true);

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varid})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varid==event.target.value)[0];
    var dd=[];
    if(result.subgrp.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varid})
     });
    }
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varid==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varid})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if(defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:"SG"}});
    }
  }, [allCountries,countries])

  useEffect(async () => {
    if(defaultValue && allStates.length>0){
      handleStateChange({target:{value:"SG"}});
      setDefaultValue(false);
    }
  }, [allStates])
  
  function handlePostalChange(event){
    const postalDiv = event.label.split(' ');
    var postCode="00";
    for (let index = 0; index < postalDiv.length; index++) {
      if(Number(postalDiv[index])>0){
        postCode=postalDiv[index];
      }
    }
    setPostValue(postCode);
    setAddValue(event.value);
    setAddValueChange(event.value);
  }

  useEffect(async () => {
    if(addValue){
      window.setPostalCode(addValue);
    }
  }, [addValueChange])

  const filterPostalCodes = async (inputValue) => {
    var result = await commonGet(null,`https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=Y&getAddrDetails=Y&pageNum=1`,true);
    var dd=[];
    if(result.data.results && result.data.results.length >0){
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL +"\n"+element.ADDRESS, value:  element.ADDRESS})
        // dd.push({ label: element.ADDRESS, value:  element.SEARCHVAL})
    });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if(inputValue.length>1){
        setTimeout(() => {
          resolve(filterPostalCodes(inputValue));
        }, 1000);
      }
  });

  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
          <div className="account-login">
            <div className="page-title">
              <h2>Individual Sign Up</h2>
            </div>
            <Formik
              initialValues={individualSignUpData}
              enableReintialize={true}
              validationSchema={Yup.object().shape({
                username: Yup.string()
                  .min(6, "Username is too Short!")
                  .required("Username is required"),
                email: Yup.string()
                  .email("Email is invalid")
                  .required("Email is required"),
                passWord: Yup.string()
                  .min(6, "Password is too Short!")
                  .max(15, "Password is too Long!")
                  .required("Password is required"),
                cPassWord: Yup.string()
                  .min(6)
                  .oneOf([Yup.ref("passWord"), null], "Passwords must match")
                  .required("Confirm your password"),
                fName: Yup.string()
                  .min(2)
                  .max(25)
                  .required("First name is required"),
                lName: Yup.string()
                  .min(2)
                  .max(25)
                  .required("Last name is required"),
                gender: Yup.string().required("Gender is required"),
                address: Yup.string()
                  // .min(15)
                  .max(200)
                  .required("Address is required"),
                city: Yup.string(),//.required("Please select your city"),
                // zipCode: Yup.string().required(
                //   "Please enter your zip/postal code"
                // ),
                country: Yup.string().required('Country is required'),
                // state: Yup.string().required(()=>{if(stateValue) return false; else return "State is required"}),
                contactNo: Yup.string()
                  .min(8)
                  .required("Please enter your contact number"),
                confirmationBox: Yup.bool().oneOf(
                  [true],
                  "Please accept terms & conditions"
                ),
              })}
              validate={(values) => {
                let errors = {};
                if (!dob) {
                  errors.dob = "Date of birth is required.";
                }
                if(addValue==''){
                  errors.address1 = "Address 1 is required";
                }
                else if(addValue.length>150){
                  errors.address1 = "Address 1 must be at most 150 characters";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                if(!postValue){
                  toast.warning('Please enter your zip/postal code !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Flip,
                  });
                  return false;
                }
                signUpFormSubmitHandler(values);
                setSubmitting(false);
                // resetForm();
              }}
            >
              {(props) => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                } = props;
                return (
                  <Form onSubmit={handleSubmit}>
                    <fieldset className="col1-set">
                      {/* <!-- <div className="col-1 new-users"><strong>New Customers</strong>
                    <div className="content">
                      <p>By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.</p>
                      <div className="buttons-set">
                        <button onclick="window.location='http://demo.magentojtv.com/computerstore/customer/account/create/';" className="button create-account" type="button"><span>Create an Account</span></button>
                      </div>
                    </div>
                    </div> --> */}
                      <div className="col-1 registered-users">
                        <strong>Account Information</strong>
                        <div className="content">
                          <p>
                            Please ensure your details are complete and
                            accurate. Your profile details will be used as your
                            default billing information on checkout process.
                          </p>
                          <hr />
                          <div className="form-list">
                            <Row>
                            <Col sm={6}>
                                <InputField
                                  Labels="Username"
                                  Type="username"
                                  Name="username"
                                  value={values.username}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.username}
                                  className={(errors.username && touched.username) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Password"
                                  Type="password"
                                  Name="passWord"
                                  value={values.passWord}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.passWord && touched.passWord
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Confirm Password"
                                  Type="password"
                                  Name="cPassWord"
                                  value={values.cPassWord}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.cPassWord && touched.cPassWord
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <hr />
                    <fieldset className="col1-set">
                      {/* <!-- <div className="col-1 new-users"><strong>New Customers</strong>
                          <div className="content">
                            <p>By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.</p>
                            <div className="buttons-set">
                              <button onclick="window.location='http://demo.magentojtv.com/computerstore/customer/account/create/';" className="button create-account" type="button"><span>Create an Account</span></button>
                            </div>
                          </div>
                        </div> --> */}
                      <div className="col-1 registered-users">
                        <strong>Personal Information</strong>
                        <div className="content">
                          <br />
                          <div className="form-list">
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="First Name"
                                  Type="text"
                                  Name="fName"
                                  value={values.fName}
                                  onChange={e=>{handleChange(e)}}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.fName && touched.fName
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Last Name"
                                  Type="text"
                                  Name="lName"
                                  value={values.lName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.lName && touched.lName
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Email Address"
                                  Type="email"
                                  Name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.email}
                                  className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                              <Col sm={6}>
                                <label>Gender</label>
                                <br />
                                <label style={{ paddingRight: "5px" }}>
                                  <input
                                    type="radio"
                                    name="gender"
                                    value="Male"
                                    checked={values.gender === "Male"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  Male
                                </label>
                                <label>
                                  <input
                                    type="radio"
                                    name="gender"
                                    value="Female"
                                    checked={values.gender === "Female"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  Female
                                </label>
                                {errors.gender && touched.gender ? (
                                  <>
                                    <span
                                      style={{
                                        color: "red",
                                        paddingLeft: "20px",
                                      }}
                                    >
                                      {" ! "} {errors.gender}{" "}
                                    </span>
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                              {/* <DatePicker
                                Labels="Date of Birth"
                                isOpen={isOpen}
                                onClose={() => setIsOpen(false)}
                                defaultValue={new Date(2022, 8, 8)}
                                minDate={new Date(2022, 10, 10)}
                                maxDate={new Date(2023, 0, 10)}
                                headerFormat='DD, MM dd'
                              /> */}
                              <CustomDateTimePicker 
                                Labels="Date of Birth"
                                startYear={1970}
                                value={new Date(dob)}
                                onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setDob(e);}}
                                className={"form-control" +(errors.dob && touched.dob ) ? 'is-invalid' : ''}
                              />

                                {/* <InputField
                                  Labels="Date of Birth"
                                  Type="date"
                                  Name="dob"
                                  value={values.dob}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.dob && touched.dob
                                      ? " is-invalid"
                                      : "")
                                  }
                                /> */}
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Contact No."
                                  Type="number"
                                  Name="contactNo"
                                  value={values.contactNo}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.contactNo && touched.contactNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <label>Zip / Postal Code</label>
                                  <RASelect
                                    classNamePrefix="lp-copy-sel customPostalCodeSelect "
                                    defaultOptions 
                                    cacheOptions 
                                    onChange={e=>{handlePostalChange(e);}}
                                    onBlur={handleBlur}
                                    loadOptions={promiseOptions}
                                    className={
                                      (errors.zipCode && touched.zipCode
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Address 1"
                                  Type="text"
                                  Name="address1"
                                  value={addValue}
                                  onChange={e=>{handleChange(e); setAddValue(e.target.value)}}
                                  onBlur={handleBlur}
                                  className={" customAddrField "}
                                />
                              </Col>
                            </Row>
                            <Row>
                            
                              {/* <Col sm={6}>
                                <InputField
                                  Labels="Zip / Postal Code"
                                  Type="number"
                                  Name="zipCode"
                                  value={postValue}
                                  onChange={e=>{handlePostalChange(e); handleChange(e);}}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.zipCode && touched.zipCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col> */}
                              <Col sm={6}>
                                <InputField
                                  Labels="Address 2"
                                  Type="text"
                                  Name="address"
                                  value={values.address}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.address && touched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Country"
                                    Name="country"
                                    placeHolder="Select Your Country"
                                    options={countries}
                                    value={values.country}
                                    onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.country && touched.country
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                              {/*<Row>
                             <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="State/Province"
                                    Type="text"
                                    Name="state"
                                    placeHolder="Select Your State"
                                    options={states}
                                    value={values.state}
                                    onChange={e=>{handleStateChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.state && touched.state
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col> 
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="City"
                                    Type="text"
                                    Name="city"
                                    placeHolder="Select Your City"
                                    value={values.city}
                                    onChange={e=>{handleCityChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    options={cities}
                                    className={
                                      errors.city && touched.city
                                        ? " is-invalid"
                                        : ""
                                    }
                                  />
                                </div>
                              </Col>
                            </Row> */}
                            <hr />
                            <li>
                              <Field type="checkbox" name="confirmationBox" />
                              {"  "}
                              {errors.confirmationBox &&
                                touched.confirmationBox ? (
                                <>
                                  <span style={{ color: "red" }}>
                                    {" ! "} {errors.confirmationBox}{" "}
                                  </span>
                                  <br />
                                </>
                              ) : (
                                ""
                              )}
                              <label>
                                <span className="button"> </span>
                                <strong> SUBSCRIBE TO OUR NEWSLETTER</strong>
                              </label>
                              <br />
                              <p>
                                Be the first to receive exclusive offers and the
                                latest news on our products and services
                                directly in your inbox. You may unsubscribe any
                                time.
                              </p>

                              <label>
                                <strong>
                                  By providing my information, I acknowledge and
                                  accept the terms of Pacific eShop
                                  <Link to="/">Privacy Policy</Link> and
                                  <Link to="/">Terms of Service</Link>
                                </strong>
                              </label>
                              <br />
                            </li>
                          </div>
                          <br />

                          <div className="buttons-set">
                            <button
                              name="send"
                              type="submit"
                              className="button login"
                            >
                              <span>Register</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </Container>
      </section>

      <BrandLogoSlider />
    </>
  );
};

export default IndividualSignUp;
